import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import Menu from './components/menu'
import InWinNotification from 'shared/components/inwinNotification'

import * as styles from './styles'

const LayoutComponent = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkScreenSize = () => {
      // Show mobile notifications for devices up to 767px (phones)
      setIsMobile(window.innerWidth <= 767)
    }

    checkScreenSize()
    window.addEventListener('resize', checkScreenSize)

    return () => window.removeEventListener('resize', checkScreenSize)
  }, [])

  return (
    <div css={styles.container}>
      {/* Only show InWinNotification on mobile devices */}
      {isMobile && <InWinNotification />}
      <Menu />
      <div css={styles.main}>
        <section css={styles.section}>{children}</section>
      </div>
    </div>
  )
}

LayoutComponent.propTypes = {
  children: PropTypes.node.isRequired,
}

export default LayoutComponent
